// extracted by mini-css-extract-plugin
export default {"container":"AddSlideCard_container__EyQBj","content":"AddSlideCard_content__lGgVP","hasNoSlides":"AddSlideCard_hasNoSlides__ZI8m7"};